export const SENSOR_RESOLUTION_WARNING_MESSAGES = {
  HSI_5_3M: `
    <ol>
      <li>Each line in the area of interest (AOI) must be at least 5km and no more than 25km long.</li>
      <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
      <li>The start of the time of interest (TOI) must be at least three days after the submission date, and the end date must be at least 30 days after the start date of the TOI. Please change your TOI or choose an alternative provider.</li>
      <li>The area of interest (AOI) requested should at least be 100 sqkm for the standard tasking and 50 sqkm for the priority tasking.</li>
    </ol>
  `,

  HSI_10M: `
    <ol>
      <li>The sensor does not have cloud cover and holdback selection options.</li>
      <li>The start of the time of interest (TOI) must be at least three days after the submission date and the end date is within 14 days from the submission date.</li>
    </ol>
  `
};
